import {
  Box,
  BoxProps,
  HStack,
  ProgressProps,
  VStack,
  chakra,
  forwardRef,
} from '@chakra-ui/react';
import _ from 'lodash';
import React, { useMemo } from 'react';

export interface StackedColorBarsProps {
  colors: string[];
  values: number[];
  children: React.ComponentType<ProgressProps>;
}

export const StackedColorBars = chakra(
  React.forwardRef<HTMLDivElement, StackedColorBarsProps>((props, ref) => {
    const { colors, values, children: Children, ...other } = props;

    const rows = useMemo(() => {
      return colors.map((c, i) => ({
        color: c,
        value: values[i],
      }));
    }, [colors, values]);

    return (
      <VStack spacing={0} min-width={'100%'} {...other} ref={ref}>
        {rows.map((r, i) => (
          <Children
            key={i}
            value={r.value}
            width="100%"
            colorScheme={r.color}
            size="lg"
            borderRadius={0}
          />
        ))}
      </VStack>
    );
  })
);

export interface InlineColorBarsProps {
  colors: string[];
  values: any[];
  render?: React.ComponentType<BoxProps>;
  // children: React.ComponentType<ProgressProps>;
}

export const InlineColorBars = forwardRef<InlineColorBarsProps, 'div'>(
  (props, ref) => {
    const { colors: colorSchemes, values, render: Render, ...other } = props;

    const parsedValues = useMemo(() => {
      return values.map((rV) => parseFloat(rV || '0'));
    }, [values]);

    const max = useMemo(() => {
      return _.max(parsedValues) || 0;
    }, [parsedValues]);

    const rows = useMemo(() => {
      let leftPtr = 0;

      let results = colorSchemes.map((c, i) => {
        const value = ((parsedValues[i] || 0) / max) * 100;
        const left = leftPtr;
        leftPtr += left;

        const result = {
          color: c,
          rawValue: parsedValues[i],
          value,
          left,
        };
        return result;
      });

      return results;
    }, [colorSchemes, parsedValues, max]);

    console.info('stats', { max });
    const Component = Render || Box;

    return (
      <HStack
        spacing={0}
        sx={{ position: 'relative', overflow: 'hidden' }}
        py={{ base: 2, md: 4 }}
        ref={ref}
        my={{ base: 2, md: 4 }}
        bg="bg-muted"
        borderRadius={'lg'}
        {...other}
      >
        {rows.map((r, i) => (
          <Component
            key={i}
            w={`${r.value}%`}
            bg={r.color}
            height="100%"
            // borderRadius={'lg'}
            sx={{
              position: 'absolute',
              left: r.left,
              top: 0,
            }}
          />
        ))}
      </HStack>
    );
  }
);
